export type PmEntityActionType = "created" | "updated" | "deleted" | "queried";

export interface PmEntityActionPayload {
  action: PmEntityActionType;
  entityType: string;
  uuid?: string;
  name?: string;
  status?: string;
  hubPath?: string;
}

export interface PmEntityListEntry {
  entityType: string;
  uuid?: string;
  name?: string;
  status?: string;
}

export interface PmEntityListPayload {
  entities: PmEntityListEntry[];
}

const ENTITY_ACTION_RE = /```pm-entity-action\s*([\s\S]*?)```/i;
const ENTITY_LIST_RE = /```pm-entity-list\s*([\s\S]*?)```/i;

function parseJsonBlock<T>(content: string, re: RegExp): T | null {
  const match = content.match(re);
  if (!match?.[1]) return null;
  try {
    return JSON.parse(match[1].trim()) as T;
  } catch {
    return null;
  }
}

export function parsePmEntityAction(content: string): PmEntityActionPayload | null {
  return parseJsonBlock<PmEntityActionPayload>(content, ENTITY_ACTION_RE);
}

export function parsePmEntityList(content: string): PmEntityListPayload | null {
  return parseJsonBlock<PmEntityListPayload>(content, ENTITY_LIST_RE);
}

export function collectPmEntityActions(
  messages: Array<{ role: string; content: string }>,
): PmEntityActionPayload[] {
  const actions: PmEntityActionPayload[] = [];
  for (const m of messages) {
    if (m.role !== "assistant") continue;
    const parsed = parsePmEntityAction(m.content);
    if (parsed) actions.push(parsed);
  }
  return actions;
}
